export function formatPrice(value: number): string {
  return Math.abs(parseInt(value))
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export function renderCurrency(amount: number) {
  return <div>{formatPrice(amount)}</div>
}

export function renderCurrencyColumn(title: string) {
  return (
    <div>
      {title}{' '}
      <span style={{ fontSize: '12px', fontWeight: 500, color: '#00000073' }}>
        ریال
      </span>
    </div>
  )
}
